var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"span",on:{"click":function($event){return _vm.changeLang()}}},[_vm._v("EN/中文")])])
}
var staticRenderFns = []

export { render, staticRenderFns }